import request from '../request';

const serve = {
  queryRoleList(params) {
    return request.post('/ubm/role/queryPage', params);
  },
  addRole(params) {
    return request.post('/ubm/role/insertByCompany', params);
  },
  deleteRole(params) {
    return request.post('/ubm/role/batchDelete', params);
  },
  copyRole(params) {
    return request.post('/ubm/role/copy', params);
  },
  updateRole(params) {
    return request.post('/ubm/role/update', params);
  },
  checkAuth(params) {
    return request.post('/ubm/role/queryRoleAuthority', params);
  },
  // queryDataAuth: function (params) {
  //     return request.post('/ubmAuthority/selectTree', params)
  // },
  queryDataAuth(params) {
    return request.post('/ubm/role/queryRoleTree', params);
  },
  addDataAuth(params) {
    return request.post('/ubm/role/roleAddAuthority', params);
  },
  checkDataAuth(params) {
    return request.post('/ubm/role/queryRoleAuthorityTree', params);
  },
  // 查询员工
  queryUser(params) {
    return request.post('/user-center/member/queryPage', params);
  },
  // 查询 审批有权限员工
  queryOrderAuditPage(params) {
    return request.post('/user-center/member/queryOrderAuditPage', params);
  },
  // 新增员工
  insertUser(params) {
    return request.post('/user-center/member/addMember', params);
  },
  // 查询公司所有角色
  queryUserAllRoles(params) {
    return request.post('/ubm/role/roleListForCompany', params);
  },
  // 查询用户已有角色
  queryUserRole(params) {
    return request.post('/ubm/member/queryUserRole', params);
  },
  // 给用户添加角色
  insertRole(params) {
    return request.post('/ubm/member/addRole', params);
  },
  // 根据用户返回数据权限
  queryUserDataAuth(params) {
    return request.post('/ubm/dataRight/getListByMember', params);
  },
  // 给用户添加数据权限
  insertDataAuth(params) {
    return request.post('/ubm/dataRight/categoryInsert', params);
  },
  // 查询全部分类
  queryAllCategory(params) {
    return request.post('/product/category/selectAllCategoryList', params);
  },
  // 根据用户返回数据权限树
  queryUserDataAuthTree(params) {
    return request.post('/ubm/dataRight/getCategoryTree', params);
  },
  // //查询用户所在部门
  // queryDepartmentTree: function (params) {
  //     return request.post('/ubm/organization/selectTree', params)
  // },
  // 查询用户所在部门
  queryDepartmentTree(params) {
    return request.post('/ubm/organization/selectTreeEnable', params);
  },
  // 根据登录名查询员工信息
  queryUserInfo(params) {
    return request.post('/user-center/member/queryListByMemberName', params);
  },
  // 员工关联公司
  relationCompany(params) {
    return request.post('/user-center/member/relationCompany', params);
  },
  // 查看用户已有权限
  checkHasAuth(params) {
    return request.post('/ubm/ubmAuthority/memberAuthTree', params);
  },
  // 查看用户已有角色
  checkHasRole(params) {
    return request.post('/ubm/member/queryUserRole', params);
  },
  // 重置密码
  resetPassword(params) {
    return request.post('/user-center/member/resetPassword', params);
  },
  // 根据memberId来获取部门信息

  getDepartmentById(params) {
    return request.post('/user-center/member/queryById', params);
  },
  // 修改员工
  updateUser(params) {
    return request.post('/user-center/member/modifyMember', params);
  },
  // 获取员工方向接口
  getBusinessType(params) {
    return request.post('/user-center/member/getBusinessTypeScope', params);
  },
  // 按钮权限
  queryBackButton(params) {
    return request.post('/ubm/button/queryBackButton', params, {
      preventRepeat: false,
    });
  },
  // 页面权限
  checkMemuAuth(params) {
    return request.fetch('/ubm/ubmAuthority/checkMemuAuth', params, {
      preventRepeat: false,
    });
  },
  // 获取员工部门/member/queryById
  queryDepartmentInfo(params) {
    return request.post('/user-center/member/queryById', params);
  },
  // 删除员工/member/delete
  deleteUser(params) {
    return request.post('/user-center/member/batchDelete', params);
  },
  // 统一身份账号查询
  queryUnityIdentity(params) {
    return request.post('/security/uicMember/queryByName', params);
  },
  // 用户已有角色(分页)（不区分系统）
  queryUserRolePage(params) {
    return request.post('/ubm/member/queryUserRolePage', params);
  },
  // 申请查看角色
  queryApplyPage(params) {
    return request.post('/ubm/roleApply/queryApplyPage', params);
  },
  // 申请查看角色记录
  myApplyPage(params) {
    return request.post('/ubm/roleApply/myApplyPage', params);
  },
  // 批量提交角色申请
  batchAdd(params) {
    return request.post('/ubm/roleApply/batchAdd', params);
  },
  // 查询待审批角色申请
  queryNeedApprovePage(params) {
    return request.post('/ubm/roleApply/queryNeedApprovePage', params);
  },
  // 角色审批通过
  rolePass(params) {
    return request.post('/ubm/roleApply/pass', params);
  },
  // 角色审批拒绝
  roleRefuse(params) {
    return request.post('/ubm/roleApply/refuse', params);
  },
  // 角色审批记录
  approveLogPage(params) {
    return request.post('/ubm/roleApply/approveLogPage', params);
  },
  // 根据roldId查询角色  checkAuth查权限
  queryByRoleId(params) {
    return request.post('/ubm/roleApply/queryByRoleId', params);
  },
  queryByRoleIdList(params) {
    return request.post('/ubm/roleApply/queryByRoleIdList', params);
  },
  //当前用户所在公司 是否南京阀门产业链白名单，是返回true，否则返回false
  isNanJingWhite(params) {
    return request.post('/user-center/companyType/isNanJingWhite', params);
  },
};

export default serve;
